
import { Vue, Component, Prop } from "vue-property-decorator";
import randomColor from "randomcolor";

@Component
export default class TileListUsers extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(Array) readonly items!: any[];

  initialColor() {
    return randomColor({
      luminosity: "dark",
    });
  }

  getZIndex(index: number) {
    switch (index) {
      case 0:
        return "z-30";
      case 1:
        return "z-20 -ml-1";
      case 2:
        return "z-10 -ml-1";
      case 3:
        return "z-0 -ml-1";
      default:
        return null;
    }
  }
}
